const transitionaryStatuses = ['launching', 'updating', 'pausing', 'stopping', 'archiving'];

export const selectStatusValidForPublish = campaign => !transitionaryStatuses.includes(campaign.status);
